<template>
  <div class="deposit-detail-container">
    <SidebarNav @update:sidebarNavCollapsed="sidebarNavCollapsed = $event" />
    <SearchBar :sidebar-nav-collapsed="sidebarNavCollapsed" />
    <div
      class="deposit-detail-content"
      :class="{['deposit-detail-content-sidebar-collapse']: sidebarNavCollapsed}"
    >
      <div class="deposit-detail-content-sub-container">
        <div class="options-bar">
          <div class="back-to-deposits" @click="() => navigateTo('deposits')" :id="getElementId('go_back')">
            <img src="@/app/assets/images/back.svg" alt="Back to deposits icon" />
            <span>{{ $t('deposits.actions.backToDeposits') }}</span>
          </div>
        </div>

        <div class="loading-message" v-if="!settlement">
          Fetching deposit...
        </div>
        <div class="main-layout-container" v-else>
          <div class="cl-dock__main">
            <div class="layout-container">
              <div class="cards">
                <div class="card-container first-card">
                  <div class="card">
                    <SettlementInfo :settlement="settlement" />
                  </div>
                </div>

                <div class="card-container" id="overview">
                  <div class="card">
                    <SettlementOverview :settlement="settlement" />
                  </div>
                </div>
                <div class="card-container" id="breakdown">
                  <div class="card">
                    <SettlementBreakdown :settlement="settlement" v-if="settlement.breakdown" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cl-dock__sidebar">
            <TableOfContents :sections="sections" />
          </div>
        </div>
        <PortalFooter />
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNav from "@/components/SidebarNav";
import {portalCheckMixin} from "@/mixin/portalPageCheck";
import {navigateTo} from "@/router";
import {mapGetters} from "vuex";
import SettlementInfo from "@/components/settlements/SettlementInfo";
import SettlementBreakdown from "@/components/settlements/SettlementBreakdown";
import SettlementOverview from "@/components/settlements/SettlementOverview";
import settlements from "@/api/settlements";
import SearchBar from "@/components/SearchBar";
import PortalFooter from "@/components/portal/PortalFooter.vue";
import {PendoPrefixes} from "@/app/utils/common/constants";
import TableOfContents from "@/components/common/TableOfContents.vue";
import locales from "@/i18n/locales";

export default {
  name: "DepositDetailsView",
  components: {
    TableOfContents,
    PortalFooter,
    SearchBar,
    SettlementInfo,
    SidebarNav,
    SettlementOverview,
    SettlementBreakdown
  },
  mixins: [portalCheckMixin],
  data: function () {
    return {
      sidebarNavCollapsed: false,
      settlement: null,
      sections: [],
      titles: [
        "profile",
        "address",
      ],
    }
  },
  computed: {
    ...mapGetters('app', ['getMerchantId']),
    loading() {
      return this.settlement === null
    },
  },
  mounted() {
    this.portalChecks().then(() => {
      this.initialize();
    });
  },
  methods: {
    async initialize() {
      this.settlement = await settlements.fetchSettlementById(
          this.getMerchantId,
          this.$route.params.settlementId)

      this.sections = [
        {id: 'overview', title: locales.en.tableOfContent.overview, show: true},
        {id: 'breakdown', title: locales.en.tableOfContent.deposits.breakdown, show: true},
      ];
    },
    navigateTo: function (route) {
      navigateTo(route, false, this.$route.query);
    },
    getElementId(id) {
      return PendoPrefixes.CBpay+ this.$route.name + '-' + id;
    }
  },
}
</script>

<style lang="scss">
.deposit-detail-container {
  background: $neutral_50;
  height: 100%;
  overflow: scroll;


  & .loading-message {
    color: $primary_text_dark;
    margin-top: 52px;
  }

  & .error {
    color: #AD2311;
    background-color: #FFEBEB;
    padding: 6px 8px;
    width: 80%;
    display: flex;
    gap: 10px;
    align-items: center;
    border: 0.5px solid #DE3618;
    border-radius: 6px;
  }

  & .main-layout-container {
    display: flex;
    justify-content: space-between;
    width: 100%;

    & .cl-dock__main {
      width: calc(75% - 8px);
      margin-right: 32px;

      @media screen and (max-width: 700px) {
        width: 100%;
      }
    }

    & .cl-dock__sidebar {
      top: 50px;
      position: sticky;
      border-radius: 8px;
      width: calc(25% - 12px);
      align-self: flex-start;

      @media screen and (max-width: 700px) {
        display: none;
        width: 0;
      }
    }

    & .layout-container {
      width: 100%;
      overflow: auto;

      & .cards {
        width: 100%;

        & .card-container {
          scroll-margin-top: 70px;
          background-color: #FFFFFF;
          padding: 24px;
          border-radius: 6px;
          margin-top: 24px;

          & .card {
            width: 100%;
          }
        }

        & .first-card {
          margin-top: 0;
        }
      }

    }
  }

  & .deposit-detail-content {
    left: 256px;
    top: 0;
    position: relative;
    width: calc(100% - 256px);
    padding: 24px 32px;
    transition: all 0.2s ease-in;
    justify-content: center;
    display: flex;

    & .deposit-detail-content-sub-container {
      max-width: 1360px;
      width: 100%;
    }

    & .options-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 28px;

      & .back-to-deposits {
        cursor: pointer;
        color: $neutral_600;
        font-weight: $weight_medium;

        & span {
          margin-left: 8px;
        }
      }

      & .respond-buttons {
        display: flex;
        align-items: center;

        & button {
          margin-left: 16px;
          margin-bottom: 0;

          & .c-button__label {
            padding: 0;
          }
        }
      }
    }
  }

  & .deposit-detail-content-sidebar-collapse {
    left: 86px;
    width: calc(100% - 86px);
  }
}
</style>